module.exports = __webpack_public_path__ + "img/Foto_DCMessgeraet.9ff0d767.jpg";